import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import * as api from '../api/datavaluelookup';
import { getLookupValuesKey } from '../reducers/DataValueLookupReducer';

export const GET_LOOKUP_VALUES = 'DataValueLookup/GET_LOOKUP_VALUES';
export const GET_LOOKUP_VALUES_SUCCESS = 'DataValueLookup/GET_LOOKUP_VALUES_SUCCESS';
export const GET_LOOKUP_VALUES_FAILURE = 'DataValueLookup/GET_LOOKUP_VALUES_FAILURE';

export const getLookupValuesSuccess = (key, values) => ({
  type: GET_LOOKUP_VALUES_SUCCESS,
  payload: {
    key,
    values,
  },
});

export const getLookupValuesFailure = (key, error) => ({
  type: GET_LOOKUP_VALUES_FAILURE,
  payload: {
    key,
    error,
  },
});

export const getLookupValues = (tableName, fieldName) => async (dispatch, getState) => {
  const key = getLookupValuesKey(tableName, fieldName);

  dispatch({
    type: GET_LOOKUP_VALUES,
    payload: {
      tableName,
      fieldName,
    },
  });

  const state = getState();
  const lookupValues = _.get(state, ['dataLookupValues', key, 'dataValues']);

  if (Array.isArray(lookupValues)) {
    return lookupValues;
  }

  try {
    const response = await api.getDataValueLookup(tableName, fieldName);

    if (response.hasError) {
      throw response.errors;
    }

    dispatch(getLookupValuesSuccess(key, response.dataValues));

    return response.dataValues;
  } catch (error) {
    dispatch(handleErrors(error));
    dispatch(getLookupValuesFailure(key, error));
  }
};
